function tournaments_Reducer(state = [], action) {
    switch (action.type) {
        case 'TOURNAMENTS/SET':
            return action.tournaments;
        case 'TOURNAMENTS/CLEAR':
            return null;
        default:
            return state;
    }
}

export default tournaments_Reducer;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/tournaments.js